import 'dayjs/locale/de.js';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration.js';
import localeData from 'dayjs/plugin/localeData.js';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
import isoWeek from 'dayjs/plugin/isoWeek.js';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

export default {
    install() {
        dayjs.locale('de');
        dayjs.extend(duration);
        dayjs.extend(localeData);
        dayjs.extend(customParseFormat);
        dayjs.extend(isoWeek);
        dayjs.extend(isBetween);
        dayjs.extend(isSameOrBefore);
    },
};
